module.exports = __webpack_public_path__ + "static/RR2-9087c7b32960a28822c1b1b19235953b.jpg";